import React from 'react';

import facebook from '../../../images/Footer/facebook.svg';
import github from '../../../images/Footer/github.svg';
import linkedin from '../../../images/Footer/linkedin.svg';
import logo from '../../../images/Footer/logo_pagarme-white.svg';
import twitter from '../../../images/Footer/logo-x.svg';
import instagram from '../../../images/Footer/instagram.svg';
import youtube from '../../../images/Footer/youtube.svg';

import { Link } from '../../Link';

import * as S from './styles';
import LazyImage from '@/components/LazyLoadImage';

const medias = [
  {
    title: 'Facebook Pagarme',
    link: 'https://www.facebook.com/pagar.me',
    icon: facebook,
  },
  {
    title: 'Github Pagarme',
    link: 'https://github.com/pagarme',
    icon: github,
  },
  {
    title: 'Twitter (X) Pagarme',
    link: 'https://x.com/pagarmetech',
    icon: twitter,
  },
  {
    title: 'Instagram Pagarme',
    link: 'https://instagram.com/pagar.me',
    icon: instagram,
  },
  {
    title: 'Linkedin Pagarme',
    link: 'https://www.linkedin.com/company/pagar-me/',
    icon: linkedin,
  },
  {
    title: 'Youtube Pagarme',
    link: 'https://youtube.com/@pagarmepagamentos',
    icon: youtube,
  },
];

export const SocialMedias = () => {
  return (
    <S.Wrapper>
      <Link to="/">
        <LazyImage className="logo" src={logo} alt="Logo Pagar.me" />
      </Link>
      <S.Icons>
        {medias.map(({ title, link, icon }) => (
          <li key={title}>
            <a target="_blank" href={link}>
              <LazyImage src={icon} alt={title} />
            </a>
          </li>
        ))}
      </S.Icons>
    </S.Wrapper>
  );
};
